import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {SerializedShadowOptions} from '@postermywall/fabricjs-2';

export function useGetKeyFromShadowOfActiveItem<T extends keyof SerializedShadowOptions>(key: T): SerializedShadowOptions[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const itemObject = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (itemObject && 'shadow' in itemObject && itemObject.shadow?.[key] !== undefined) {
      return itemObject.shadow[key];
    }

    return undefined;
  });
}
